<template>
  <div>
    <el-dialog title="区域代理审核" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" ref="form">
        <el-form-item label="审核状态" :label-width="formLabelWidth" prop="apply_status" :rules="[{required: true,message: '请选择审核状态'}]">
          <div v-if="!form.audit_time">
            <el-radio v-model="form.apply_status" :label="20">审核通过</el-radio>
            <el-radio v-model="form.apply_status" :label="30">驳回</el-radio>
          </div>
          <div v-else>
            <span v-if="form.apply_status == 20" class="blue f16">审核通过</span>
            <span v-else class="red f16">驳回</span>
          </div>
        </el-form-item>
        <div v-if="form.apply_status == 30">
            <el-form-item label="驳回原因" :label-width="formLabelWidth" prop="reject_reason" :rules="[{required: true,message: '请输入驳回原因'}]">
                <p v-if="form.reject_reason" class="f16">{{form.reject_reason}}</p>
                <el-input v-model="form.reject_reason" autocomplete="off" :disabled="form.audit_time" v-else></el-input>
            </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!form.audit_time">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="editApplyStatus">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RegionagentApi from '@/api/regionagent.js';
export default {
  data() {
    return {
        form: {
            apply_status: 20,
            reject_reason: '',
        },
        status: '',
        reject_reason: '',
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false
    };
  },
  props: ['open_audit', 'model'],
  created() {
    this.dialogVisible = this.open_audit;
    this.form = this.model;
  },
  methods: {
    /*修改用户*/
    editApplyStatus() {
      let self = this;
      let params = {};
      params.id = this.form.id;
      params.apply_status = this.form.apply_status?this.form.apply_status:20;
      params.reject_reason = this.form.reject_reason;
      self.$refs.form.validate((valid) => {
        if (valid) {
            RegionagentApi.applyAudit(params, true)
            .then(data => {
            self.$message({
                message: data.msg,
                type: 'success'
            });
            self.dialogFormVisible(true);
            })
            .catch(error => {});
        }
      })
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/regionagent/regionagent/dialog/Audit.vue